/**
 * @file
 * useTimer custom hook.
 *
 * useTimer contains next attributes:
 * @param time {number}
 */

import { useEffect, useState } from 'react';

export function useTimer(time) {
  /**
   * Set Waiting timer
   */
  const [timer, setTimer] = useState(time);

  /**
   * Set timer start & update
   */
  useEffect(() => {
    const id = setInterval(() => setTimer(timer - 1000), 1000);
    return () => clearInterval(id);
  }, [timer]);

  return timer;
}
